var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerSupportBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.000000, 13.000000)",
    stroke: "currentColor",
    strokeWidth: 2.2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65,53 C61.4872452,61.4972152 52.5405588,66.5448101 43,68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,29 L9,28.0626184 C9,13.2017623 20.6205249,0.512068722 35.5580532,0.015636113 C51.1754278,-0.502697935 64,11.9329389 64,27.3457113 L64,29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7052186,53 L7.21993418,53 C3.24814292,53 0,49.7825223 0,45.8500497 L0,36.1544191 C0,32.2204568 3.25115186,29 7.22444758,29 L13.0783263,29 C14.6850964,29 16,30.3018868 16,31.8927507 L16,49.7363456 C16,51.531281 14.5181006,53 12.7052186,53 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2947814,53 L66.7800658,53 C70.7518571,53 74,49.7825223 74,45.8500497 L74,36.1544191 C74,32.2204568 70.7488481,29 66.7755524,29 L60.9216737,29 C59.3149036,29 58,30.3018868 58,31.8927507 L58,49.7363456 C58,51.531281 59.4818994,53 61.2947814,53 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,67.9992862 C43,70.7615989 40.7612793,73 38,73 C35.237293,73 33,70.7615989 33,67.9992862 C33,65.2384011 35.237293,63 38,63 C40.7612793,63 43,65.2384011 43,67.9992862 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupportBlack);
export default __webpack_public_path__ + "static/media/Customer Support Black.46f244e8ab68d1849e1c90121d70039a.svg";
export { ForwardRef as ReactComponent };